import React from "react";

const styleiTunes = {
    display: 'inline-block',
    width: 135, height: 40,
    objectFit: 'contain',
    overflow: 'hidden',
    padding: 2,
}

const styleGoogle = {
    display: 'inline-block',
    width: 135, height: 40,
    objectFit: 'cover',
    overflow: 'hidden',
}

export const iTunes = () => (<a href="https://itunes.apple.com/us/app/caazam/id1215087815?mt=8">
    <img alt='Download from App Store' src='https://linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg' style={styleiTunes} /></a>);


export const GooglePlay = () => (<a href='https://play.google.com/store/apps/details?id=com.caazam.caazamapp&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
    <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' style={styleGoogle} /></a>);


// WEBPACK FOOTER //
// ./src/Constants/AppStores.js